import React from 'react';
import AppRoutes from '../routes';
import Footer from '../components/willow/footer';
import Header from '../components/willow/header';
import HomePage from '../pages/willow/home_page';
import ContactPage from '../pages/willow/contact_page';
import MediaRoom from '../pages/willow/media_room';
import HomeMy from '../pages/willow/home_page_my';
import ShippingPage from '../pages/willow/shipping_page';

export default function WillowTemplate(props) {
    return (
        <React.Fragment>
            <Header />
            <AppRoutes
                homePage={HomePage}
                contactPage={ContactPage}
                mediaRoom={MediaRoom}
                homeMy={HomeMy}
                shippingPage={ShippingPage}
            />
            <Footer />
        </React.Fragment>
    )
}
